export const GET_REGULAR_SERVICES_FOR_TYPE = 'GET_REGULAR_SERVICES_FOR_TYPE';
